<template>
    <div :style="style" ></div>
</template>

<script>
export default {
  props: {
    grow: {
      type: String,
      default: '1'
    },
    shrink: {
      type: String,
      default: '1'
    },
    basis: {
      type: String,
      default: null
    }
  },
  computed: {
    style() {
      return {
        flexBasis: this.basis === null ? "auto" : this.basis,
        flexGrow: this.grow,
        flexShrink: this.shrink
      };
    }
  }
};
</script>


